import produce from "immer";
import { AIProjectActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialProjectState } from "./aiProjects.types";
import {
  CLEAR_PROJECTS_STATE,
  CLEAR_TEMP_PROJECT,
  FETCH_PROJECT_DETAILS_FAILED,
  FETCH_PROJECT_DETAILS_PROGRESS,
  FETCH_PROJECT_DETAILS_SUCCESS,
  FETCH_PROJECT_SUMMARY_LIST_FAILURE,
  FETCH_PROJECT_SUMMARY_LIST_PROGRESS,
  FETCH_PROJECT_SUMMARY_LIST_SUCCESS,
  FETCH_TEMP_PROJECT_FAILURE,
  FETCH_TEMP_PROJECT_LIST_FAILURE,
  FETCH_TEMP_PROJECT_LIST_PROGRESS,
  FETCH_TEMP_PROJECT_LIST_SUCCESS,
  FETCH_TEMP_PROJECT_PROGRESS,
  FETCH_TEMP_PROJECT_SUCCESS,
} from "./aiProjectsActions";
import { LoadState } from "../../constants/enums";

export const aiProjectsReducer = (
  state: IStoreState["projects"] = initialProjectState,
  action: AIProjectActions
) => {
  switch (action.type) {
    case FETCH_PROJECT_DETAILS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.projectDetailsLoading = LoadState.InProgress;
        draftState.projectDetails = initialProjectState["projectDetails"];
      });
      return newState;
    }
    case FETCH_PROJECT_DETAILS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.projectDetailsLoading = LoadState.Loaded;
        draftState.projectDetails = data;
      });
      return newState;
    }
    case FETCH_PROJECT_DETAILS_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.projectDetailsLoading = LoadState.Failed;
        draftState.projectDetails = initialProjectState["projectDetails"];
        draftState.projectDetailsError = error;
      });
      return newState;
    }

    // case FETCH_RECONCILIATION_LIST_PROGRESS: {
    //       const newState = produce(state, (draftState) => {
    //         draftState.loading = LoadState.InProgress;
    //         draftState.list = [];
    //         draftState.totalRecords = 0;
    //       });
    //       return newState;
    //     }
    //     case FETCH_RECONCILIATION_LIST_SUCCESS: {
    //       const { data, totalRecords } = action.payload;
    //       const newState = produce(state, (draftState) => {
    //         draftState.loading = LoadState.Loaded;
    //         draftState.list = data;
    //         draftState.totalRecords = totalRecords;
    //       });
    //       return newState;
    //     }
    //     case FETCH_RECONCILIATION_LIST_FAILED: {
    //       const newState = produce(state, (draftState) => {
    //         draftState.loading = LoadState.InProgress;
    //         draftState.list = [];
    //         draftState.totalRecords = 0;
    //       });
    //       return newState;
    //     }

    case FETCH_PROJECT_SUMMARY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.projectSummaryLoading = LoadState.InProgress;
        draftState.projectSummaryList =
          initialProjectState["projectSummaryList"];
      });
      return newState;
    }

    case FETCH_PROJECT_SUMMARY_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.projectSummaryLoading = LoadState.Loaded;
        draftState.projectSummaryList = data;
        draftState.projectSummaryTotalRecords = totalRecords;
      });
      return newState;
    }

    case FETCH_PROJECT_SUMMARY_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.projectSummaryLoading = LoadState.Failed;
        draftState.projectSummaryList =
          initialProjectState["projectSummaryList"];
        draftState.projectSummaryTotalRecords = 0;
      });
      return newState;
    }

    case FETCH_TEMP_PROJECT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.projectTempLoading = LoadState.InProgress;
        draftState.projectTempList = initialProjectState["projectTempList"];
      });
      return newState;
    }

    case FETCH_TEMP_PROJECT_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.projectTempLoading = LoadState.Loaded;
        draftState.projectTempList = data;
        draftState.projectTempTotalRecords = totalRecords;
      });
      return newState;
    }

    case FETCH_TEMP_PROJECT_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.projectTempLoading = LoadState.Failed;
        draftState.projectTempList = initialProjectState["projectTempList"];
        draftState.projectTempTotalRecords = 0;
      });
      return newState;
    }

    case FETCH_TEMP_PROJECT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.projectTempLoading = LoadState.InProgress;
        draftState.projectTemp = initialProjectState["projectTemp"];
      });
      return newState;
    }

    case FETCH_TEMP_PROJECT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.projectTempLoading = LoadState.Loaded;
        draftState.projectTemp = data;
      });
      return newState;
    }

    case FETCH_TEMP_PROJECT_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.projectTempLoading = LoadState.Failed;
        draftState.projectTemp = initialProjectState["projectTemp"];
      });
      return newState;
    }

    case CLEAR_PROJECTS_STATE: {
      return initialProjectState;
    }

    case CLEAR_TEMP_PROJECT: {
      const newState = produce(state, (draftState) => {
        draftState.projectTempLoading = LoadState.NotLoaded;
        draftState.projectTemp = initialProjectState["projectTemp"];
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
